import type { UserPreferencesProvider } from '@atlaskit/editor-common/types';
import type { SelectionToolbarPluginOptions } from '@atlaskit/editor-plugin-selection-toolbar';

interface Props {
	options: never;
	providers: {
		userPreferencesProvider: UserPreferencesProvider | undefined;
	};
}

export function selectionToolbarPluginOptions({ providers }: Props): SelectionToolbarPluginOptions {
	return {
		preferenceToolbarAboveSelection: false,
		contextualFormattingEnabled: true,
		userPreferencesProvider: providers.userPreferencesProvider,
	};
}
